module.exports = __webpack_public_path__ + "static/Gameplay_CherryBlossom-eaf6e68a27f585ae5cb6eedac1b2d605.png";